import { DefaultButton, PrimaryButton } from "@fluentui/react";

interface IPanelFooterGestionDocumentos {
  onClick: () => void;
  texto?: string;
  texto2?: string;
  onDismiss: () => void;
  disableButton?: boolean;
}
export const PanelFooterGestionDocumentos = (
  props: IPanelFooterGestionDocumentos
) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          justifyItems: "center",
          height: "5%",
          padding: "2opx",
          margin: "20px",
        }}
      >
        <div style={{ display: "flex" }}>
          <DefaultButton
            onClick={() => {
              props.onDismiss();
            }}
            text={!props.texto2 ? "Cancelar" : props.texto2}
          />
        </div>
        <div style={{ display: "flex" }}>
          <PrimaryButton
            onClick={() => {
              props.onClick();
            }}
            text={!props.texto ? "Actualizar" : props.texto}
            disabled={
              props.disableButton != null && props.disableButton != undefined
                ? props.disableButton
                : false
            }
          />
        </div>
      </div>
    </>
  );
};
